import { Layers } from "lucide-react";
import { Pressable, StyleSheet, Text, View } from "react-native";
import { useCallback, useState } from "react";

import { useWorkspaceThreads } from "../../contexts/CompanionThreadsContext";
import { colors, radii, spacing } from "../../styles/design-system";

interface ThreadSelectorProps {
  threadId: string;
  threadName: string;
  workspaceId: string;
}

export const ThreadSelector = ({ threadId, threadName, workspaceId }: ThreadSelectorProps) => {
  const { toggleWorkspaceDrawer } = useWorkspaceThreads();
  const [isActive, setIsActive] = useState(false);

  const handleOpenThread = useCallback(() => {
    toggleWorkspaceDrawer(workspaceId);
  }, [workspaceId, toggleWorkspaceDrawer]);
  return (
    <Pressable
      style={[styles.container, isActive && styles.active]}
      onPress={handleOpenThread}
      onHoverIn={() => setIsActive(true)}
      onHoverOut={() => setIsActive(false)}
      role="button"
      accessibilityLabel="Open thread">
      <Layers size={16} color={"#475467"} />
      <Text
        style={styles.threadName}
        accessibilityLabel={threadName}
        accessibilityRole="text"
        aria-level="2"
        numberOfLines={1}
        ellipsizeMode="tail"
        role="heading">
        {threadName}
      </Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "row",
    gap: spacing.xs,
    paddingHorizontal: spacing.xs,
    paddingVertical: spacing.xxs,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: radii.lg,
  },
  active: {
    backgroundColor: colors.grey[100],
  },
  threadName: {
    color: colors.grey[600],
    fontWeight: 600,
    fontSize: 14,
  },
});
